import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=1c5152c0&scoped=true&"
import script from "./Pages.vue?vue&type=script&lang=js&"
export * from "./Pages.vue?vue&type=script&lang=js&"
import style0 from "./Pages.vue?vue&type=style&index=0&id=1c5152c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5152c0",
  null
  
)

export default component.exports